import Icon, { BaseIconProps } from '../icons/react-components/Icon'
function WarningRoundedIcon({ ...props }: BaseIconProps) {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 26 24"
        {...props}
      >
        <g clipPath="url(#WarningRoundedIcon_svg__a)">
          <path
            fill="#F7A703"
            d="M20.366 22H4.688a2.7 2.7 0 0 1-1.266-.313 2.54 2.54 0 0 1-.944-.867 2.387 2.387 0 0 1-.114-2.421l7.84-15.024c.214-.414.546-.763.956-1.006S12.044 2 12.527 2a2.67 2.67 0 0 1 1.367.37c.41.242.742.591.957 1.005l7.84 15.024a2.39 2.39 0 0 1-.115 2.422c-.232.362-.557.66-.944.866a2.7 2.7 0 0 1-1.266.313m-7.84-5c-.345 0-.677.131-.922.366a1.22 1.22 0 0 0-.382.884c0 .331.137.65.382.884s.577.366.923.366.678-.132.923-.366c.245-.235.382-.553.382-.884 0-.332-.138-.65-.382-.884a1.34 1.34 0 0 0-.923-.366m0-10c-.345 0-.677.13-.922.365a1.22 1.22 0 0 0-.382.884v5c0 .332.137.65.382.884.245.235.577.367.923.367s.678-.132.923-.367.382-.552.382-.883v-5c0-.332-.138-.65-.382-.885A1.34 1.34 0 0 0 12.527 7"
          />
        </g>
        <defs>
          <clipPath id="WarningRoundedIcon_svg__a">
            <path fill="#fff" d="M0 0h25.055v24H0z" />
          </clipPath>
        </defs>
      </svg>
    </Icon>
  )
}
export default WarningRoundedIcon
